import { gql } from '@apollo/client';
import { IMeetingPlaceSeoDescription } from '../../interfaces/meetingPlaceSeoDescription';
import { IMeetingPlacePageOfferItem } from './meetingPlacePageOfferItem';
import { IMeetingPlacePageEventItem } from './meetingPlacePageEventItem';
import { IMeetingPlacePageNewsItem } from './meetingPlacePageNewsItem';

export type TOccationTypes =
  | IMeetingPlacePageEventItem
  | IMeetingPlacePageOfferItem
  | IMeetingPlacePageNewsItem;

export interface IMeetingPlacePageOccations {
  name: string;
  slug: string;
  node_locale: string;
  occasionsCollection: {
    items: TOccationTypes[];
  };
  customizedSlug: string;
  seoDescription: IMeetingPlaceSeoDescription;
}

export const MeetingPlacePageOccasionsFragment = gql`
  fragment MeetingPlacePageOccasions on MeetingPlacePageOccasions {
    name
    slug
    # node_locale
    occasions {
      ... on Node {
        ... on MeetingPlacePageEventItem {
          ...MeetingPlacePageEventItem
        }
        ... on MeetingPlacePageOfferItem {
          ...MeetingPlacePageOfferItem
        }
        ... on MeetingPlacePageNewsItem {
          ...MeetingPlacePageNewsItem
        }
      }
    }
    # customizedSlug
    seoDescription
  }
`;

export const MeetingPlacePageOccasionsListFragment = gql`
  fragment MeetingPlacePageOccasionsList on MeetingPlacePageOccasions {
    name
    slug
    seoDescription
  }
`;
